export default function EventHandler$getAction () {
	return this.action.toString().trim();
}
